'use strict'

import $ from 'jquery';
import Highcharts from 'highcharts/highstock';
import { lib } from '../../common/Library';
import { chartLib } from '../../common/ChartLibrary';

/**
 * 個別銘柄 - 実績配当性向
 *
 * @param {string} divId 表示div id
 */
const ZaimuDpr = function(divId) {
    try {
        // グラフ生成 - データ用JSONを読み込む
        $.ajax({
            url: $('#dprJsonUrl').val(),
            dataType: 'jsonp',
            jsonpCallback: 'dpr' + $('#stockCd').val(),
            async: false
        })
        .done(function(json) {
            // グラフの生成
            createGraph(divId, json);
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.log('status:' + textStatus);
            console.log('response:' + jqXHR.responseText);
        });
    } catch (e) {
        console.log(e);
    }

    /**
     * グラフを生成
     *
     * @param {string} divId - グラフ出力先の<div>タグのID
     * @param {object} json グラフJSON
     */
    function createGraph(divId, json) {
        // カンマ表示
        Highcharts.setOptions({
            lang: {
                thousandsSep: ','
            }
        });

        $(divId).highcharts({
            title: {
                text: '実績配当性向',
                margin: 0,
                style: {
                    fontSize: 15,
                    fontWeight: 'bold'
                }
            },
            chart: {
                style: {
                    fontFamily: $('#fontFamily').val()
                },
                type: 'column',
                pinchType: '',
                zoomType: ''
            },
            legend: {
                enabled: true,
                borderWidth: 1,
                itemStyle: {
                    fontWeight: 'normal'
                },
                itemHoverStyle: {
                    cursor: 'default'
                },
                margin: 0,
                y: 15
            },
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            colors: ['#4f81bd', '#c00000'],
            xAxis: {
                type: 'category',
                categories: [
                    '0 %',
                    '0～10 %',
                    '10～20 %',
                    '20～30 %',
                    '30～40 %',
                    '40～50 %',
                    '50～60 %',
                    '60～70 %',
                    '70～80 %',
                    '80～90 %',
                    '90 %～'
                ],
                tickmarkPlacement: 'between', //目盛線の位置 between,on
                tickPosition: 'inside', //目盛線の表示場所 inside:内側 outside:外側
                labels: {
                    style: {
                        color: '#000'
                    },
                    y: 10,
                    x: 2
                },
                //ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                //補助線の設定
                tickLength: 7,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                crosshair: true //マウスホバーした時の縦線表示設定
            },
            yAxis: {
                title: '',
                labels: {
                    format: '{value:,.0f}',
                    style: {
                        color: '#000'
                    }
                },
                //縦軸補助線の設定
                gridLineColor: '#c3c3c3',
                gridLineWidth: 1,
                gridLineDashStyle: 'solid', //縦軸線スタイル dash:点線 solid:線
                //縦軸ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                //縦軸補助線の設定
                tickLength: 5,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                tickAmount: 6
            },
            tooltip: {
                positioner: function(boxWidth, boxHeight, point) {
                    return chartLib.tooltipPositioner(this, boxWidth, boxHeight, point);
                },
                formatter: function() {
                    return this.x + '<br>' + this.y.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,') + ' 銘柄';
                },
                shared: true //縦列グループ化
            },
            plotOptions: {
                series: {
                    states: {
                        inactive: {
                            //ホバーイベントのデフォルトを薄くしない（以前と同じに）
                            opacity: 1,
                        }
                    }
                },
                column: {
                    grouping: false,
                    pointPadding: -0.1,
                    borderWidth: 0,
                    /* 凡例をクリックして、グラフ情報の表示/非表示にする機能を無効 */
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    },
                    animation: false
                }
            },
            series: json
        });
    }
};

export { ZaimuDpr };
